/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../eigen_lcm/Vector3d";
import { ObstacleType_Enum, obstacleType_EnumFromJSON, obstacleType_EnumToJSON } from "./obstacle_type";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SpoofObstacleInternal {
  utime: number;
  obstacleType: ObstacleType_Enum;
  alwaysSpoof: boolean;
  id: string;
  timeAhead: number;
  radius: number;
  navPosition: Vector3dPb | undefined;
  width: number;
  length: number;
  position: number;
  yzPlane: boolean;
  distanceAhead: number;
  boxMinPoint: Vector3dPb | undefined;
  boxMaxPoint: Vector3dPb | undefined;
}

function createBaseSpoofObstacleInternal(): SpoofObstacleInternal {
  return {
    utime: 0,
    obstacleType: 0,
    alwaysSpoof: false,
    id: "",
    timeAhead: 0,
    radius: 0,
    navPosition: undefined,
    width: 0,
    length: 0,
    position: 0,
    yzPlane: false,
    distanceAhead: 0,
    boxMinPoint: undefined,
    boxMaxPoint: undefined,
  };
}

export const SpoofObstacleInternal = {
  encode(message: SpoofObstacleInternal, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.obstacleType !== 0) {
      writer.uint32(16).int32(message.obstacleType);
    }
    if (message.alwaysSpoof === true) {
      writer.uint32(24).bool(message.alwaysSpoof);
    }
    if (message.id !== "") {
      writer.uint32(34).string(message.id);
    }
    if (message.timeAhead !== 0) {
      writer.uint32(85).float(message.timeAhead);
    }
    if (message.radius !== 0) {
      writer.uint32(93).float(message.radius);
    }
    if (message.navPosition !== undefined) {
      Vector3dPb.encode(message.navPosition, writer.uint32(98).fork()).ldelim();
    }
    if (message.width !== 0) {
      writer.uint32(165).float(message.width);
    }
    if (message.length !== 0) {
      writer.uint32(173).float(message.length);
    }
    if (message.position !== 0) {
      writer.uint32(181).float(message.position);
    }
    if (message.yzPlane === true) {
      writer.uint32(240).bool(message.yzPlane);
    }
    if (message.distanceAhead !== 0) {
      writer.uint32(253).float(message.distanceAhead);
    }
    if (message.boxMinPoint !== undefined) {
      Vector3dPb.encode(message.boxMinPoint, writer.uint32(322).fork()).ldelim();
    }
    if (message.boxMaxPoint !== undefined) {
      Vector3dPb.encode(message.boxMaxPoint, writer.uint32(330).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofObstacleInternal {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofObstacleInternal();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.obstacleType = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.alwaysSpoof = reader.bool();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.id = reader.string();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.timeAhead = reader.float();
          continue;
        case 11:
          if (tag !== 93) {
            break;
          }

          message.radius = reader.float();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.navPosition = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 20:
          if (tag !== 165) {
            break;
          }

          message.width = reader.float();
          continue;
        case 21:
          if (tag !== 173) {
            break;
          }

          message.length = reader.float();
          continue;
        case 22:
          if (tag !== 181) {
            break;
          }

          message.position = reader.float();
          continue;
        case 30:
          if (tag !== 240) {
            break;
          }

          message.yzPlane = reader.bool();
          continue;
        case 31:
          if (tag !== 253) {
            break;
          }

          message.distanceAhead = reader.float();
          continue;
        case 40:
          if (tag !== 322) {
            break;
          }

          message.boxMinPoint = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 41:
          if (tag !== 330) {
            break;
          }

          message.boxMaxPoint = Vector3dPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofObstacleInternal {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      obstacleType: isSet(object.obstacleType) ? obstacleType_EnumFromJSON(object.obstacleType) : 0,
      alwaysSpoof: isSet(object.alwaysSpoof) ? globalThis.Boolean(object.alwaysSpoof) : false,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      timeAhead: isSet(object.timeAhead) ? globalThis.Number(object.timeAhead) : 0,
      radius: isSet(object.radius) ? globalThis.Number(object.radius) : 0,
      navPosition: isSet(object.navPosition) ? Vector3dPb.fromJSON(object.navPosition) : undefined,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      yzPlane: isSet(object.yzPlane) ? globalThis.Boolean(object.yzPlane) : false,
      distanceAhead: isSet(object.distanceAhead) ? globalThis.Number(object.distanceAhead) : 0,
      boxMinPoint: isSet(object.boxMinPoint) ? Vector3dPb.fromJSON(object.boxMinPoint) : undefined,
      boxMaxPoint: isSet(object.boxMaxPoint) ? Vector3dPb.fromJSON(object.boxMaxPoint) : undefined,
    };
  },

  toJSON(message: SpoofObstacleInternal): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.obstacleType !== 0) {
      obj.obstacleType = obstacleType_EnumToJSON(message.obstacleType);
    }
    if (message.alwaysSpoof === true) {
      obj.alwaysSpoof = message.alwaysSpoof;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.timeAhead !== 0) {
      obj.timeAhead = message.timeAhead;
    }
    if (message.radius !== 0) {
      obj.radius = message.radius;
    }
    if (message.navPosition !== undefined) {
      obj.navPosition = Vector3dPb.toJSON(message.navPosition);
    }
    if (message.width !== 0) {
      obj.width = message.width;
    }
    if (message.length !== 0) {
      obj.length = message.length;
    }
    if (message.position !== 0) {
      obj.position = message.position;
    }
    if (message.yzPlane === true) {
      obj.yzPlane = message.yzPlane;
    }
    if (message.distanceAhead !== 0) {
      obj.distanceAhead = message.distanceAhead;
    }
    if (message.boxMinPoint !== undefined) {
      obj.boxMinPoint = Vector3dPb.toJSON(message.boxMinPoint);
    }
    if (message.boxMaxPoint !== undefined) {
      obj.boxMaxPoint = Vector3dPb.toJSON(message.boxMaxPoint);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofObstacleInternal>, I>>(base?: I): SpoofObstacleInternal {
    return SpoofObstacleInternal.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofObstacleInternal>, I>>(object: I): SpoofObstacleInternal {
    const message = createBaseSpoofObstacleInternal();
    message.utime = object.utime ?? 0;
    message.obstacleType = object.obstacleType ?? 0;
    message.alwaysSpoof = object.alwaysSpoof ?? false;
    message.id = object.id ?? "";
    message.timeAhead = object.timeAhead ?? 0;
    message.radius = object.radius ?? 0;
    message.navPosition = (object.navPosition !== undefined && object.navPosition !== null)
      ? Vector3dPb.fromPartial(object.navPosition)
      : undefined;
    message.width = object.width ?? 0;
    message.length = object.length ?? 0;
    message.position = object.position ?? 0;
    message.yzPlane = object.yzPlane ?? false;
    message.distanceAhead = object.distanceAhead ?? 0;
    message.boxMinPoint = (object.boxMinPoint !== undefined && object.boxMinPoint !== null)
      ? Vector3dPb.fromPartial(object.boxMinPoint)
      : undefined;
    message.boxMaxPoint = (object.boxMaxPoint !== undefined && object.boxMaxPoint !== null)
      ? Vector3dPb.fromPartial(object.boxMaxPoint)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
